module.exports = "img/27.cc6c0e.webp";